import Head from "next/head"
import {renderMetaTags} from "react-datocms"
import {getItemUrl, getPropSafely} from "@/utils/utils"
import {IS_PROD, LOCALES} from "@/constants"
import {useRouter} from "next/router"
import React from "react"

function getCanonicalUrl(item, locale = LOCALES.PL) {
	const url = getItemUrl(item)
	const localePrefix = locale === LOCALES.PL ? "" : `/${locale}`
	return `${process.env.SITE_URL}${localePrefix}${url}`
}

export default function Seo({ data = [], children }) {
	const metaTags = getPropSafely(data, "_seoMetaTags", [])
	const { locale } = useRouter()
	const canonical = getCanonicalUrl(data, locale)
	const hasDisableRobotsTag = metaTags.some(({ attributes }) => attributes?.name === "robots" && attributes?.content === "noindex")

	return (
		<Head>
			<meta name="viewport" content="width=device-width, initial-scale=1" />
			<link rel="icon" href="/favicon.svg" />
			{renderMetaTags(metaTags)}
			{children}
			<link rel="canonical" href={canonical} />
			{!IS_PROD && !hasDisableRobotsTag && <meta name="robots" content="no index" />}
		</Head>
	)
}
